<template>
  <div>
    <div class="field">
      <div class="field__header" :class="{'-border' : isOpen}">
        <div class="field__title">{{value.name ? value.name : 'Checkbox'}}</div>
        <div class="field__arrow" @click="openOptions()">
          <IconPlus v-if="!isOpen" />
          <IconNegative v-else />
        </div>
      </div>
      <div class="field__details" :class="{'-border' : isOpen}" v-if="isOpen">
				<FormInput
          :isRow="true"
          :placeholder="'Checkbox adı:'"
          :required="true"
          v-model.trim="value.name"
        />
				<FormInput
          :isRow="true"
          :placeholder="'Checkbox Metni:'"
					:required="true"
          v-model.trim="value.content"
        />
				<FormInput
          :isRow="true"
          :placeholder="'Varsa Açıklaması:'"
          v-model.trim="value.description"
        />
        <FormCheckbox
          :isFieldPage="true"
          :placeholder="'Zorunlu alan mı?'"
          v-model="value.required"
        />
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openOptions: function() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>